// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_TreatmentCard_Content_TreatmentPlans_Steps_Content_TreatmentPlans($treatment_id: uuid!) {
  vaxiom_tx_plans(
    where: { deleted: { _eq: false }, tx: { _id: { _eq: $treatment_id } } }
    order_by: { name: asc_nulls_last }
  ) {
    id
    _id
    name
    appointments: tx_plan_appointments {
      id
      type_id
      next_appointment_id
      interval_to_next
      duration
      type {
        id
        display_name
        display_color_id
      }
    }
  }
}

`